const connectReader = (reader) => {
  let body = '';
  if (reader === 'wp3' || reader === 'chipper') {
    body = `ConnectionConfiguration.BluetoothConnectionConfiguration connectionConfig =
            new ConnectionConfiguration.BluetoothConnectionConfiguration(locationId);

        {+connect-reader}
        Terminal.getInstance().connectBluetoothReader(
            reader,
            connectionConfig,
            new TerminalBluetoothReaderListener(),
            new ReaderCallback() {
                @Override
                public void onSuccess(@NotNull Reader reader) {
                    final MainActivity activity = activityRef.get();
                    if (activity != null) {
                        activity.runOnUiThread(() -> {
                            // Update UI w/ connection success
                            activity.updateReaderConnection(true);
                        });
                    }
                }

                @Override
                public void onFailure(@NotNull TerminalException e) {
                    final MainActivity activity = activityRef.get();
                    if (activity != null) {
                        activity.runOnUiThread(() -> {
                            // Update UI w/ connection failure
                        });
                    }
                }
            }
        );
        {/connect-reader}`;
  } else {
    body = `ConnectionConfiguration.InternetConnectionConfiguration connectionConfig =
              new ConnectionConfiguration.InternetConnectionConfiguration(true);

    {+connect-reader}
      Terminal.getInstance().connectInternetReader(
              reader,
              connectionConfig,
              new ReaderCallback() {
                  @Override
                  public void onSuccess(@NotNull Reader reader) {
                      final MainActivity activity = activityRef.get();
                      if (activity != null) {
                          activity.runOnUiThread(() -> {
                              // Update UI w/ connection success
                              activity.updateReaderConnection(true);
                          });
                      }
                  }

                  @Override
                  public void onFailure(@NotNull TerminalException e) {
                      final MainActivity activity = activityRef.get();
                      if (activity != null) {
                          activity.runOnUiThread(() -> {
                              // Update UI w/ connection failure
                          });
                      }
                  }
              }
      );
    {/connect-reader}`;
  }
  return body;
};

export default ({keys, server, reader}) => `package com.stripe.example;

import com.stripe.stripeterminal.Terminal;
import com.stripe.stripeterminal.callable.ReaderCallback;
import com.stripe.stripeterminal.model.external.ConnectionConfiguration;
import com.stripe.stripeterminal.model.external.Reader;
import com.stripe.stripeterminal.model.external.TerminalException;

import org.jetbrains.annotations.NotNull;

import java.lang.ref.WeakReference;

public class ReaderClickListener {
    @NotNull
    private final WeakReference<MainActivity> activityRef;

    public ReaderClickListener(@NotNull WeakReference<MainActivity> weakReference) {
        activityRef = weakReference;
    }

    public void onClick(@NotNull Reader reader) {
      // When connecting to a physical reader, your integration should specify either the
      // same location as the last connection (reader.locationId) or a new location
      // of your user's choosing.
      //
      // Since the simulated reader is not associated with a real location, we recommend
      // specifying its existing mock location.
      String locationId;
      if (reader.getRegisteredLocation() != null) {
          locationId = reader.getRegisteredLocation().getId();
      } else {
          // The reader is not associated with a location. Insert business logic here to determine
          // where the reader should be registered, and pass the location ID to the reader.
          throw new RuntimeException("No location ID available");
      }

      ${connectReader(reader)}
  }
}

`;
